/**
 * Collapsible AI Insights Bar
 * 
 * Prominent, animated bar at top of Overview Dashboard that expands to show AI insights.
 * Features pulsing gradient animation to indicate "AI is alive".
 */

import React, { useState } from 'react';
import { Sparkles, ChevronDown, ChevronUp } from 'lucide-react';
import AIInsightsPanel from './AIInsightsPanel';

export function CollapsibleAIInsightsBar() {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="w-full mb-6">
      {/* Collapsible Header Bar with Pulsing Green/Teal Gradient */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full bg-gradient-to-r from-emerald-500 via-teal-500 to-cyan-500 
                   bg-[length:200%_100%] animate-gradient-x
                   shadow-lg border-b-2 border-emerald-600
                   hover:shadow-xl transition-shadow duration-300"
      >
        <div className="max-w-7xl mx-auto px-8 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Sparkles className="w-6 h-6 text-white animate-pulse" />
            <h2 className="text-xl font-bold text-white">AI Insights</h2>
            <span className="px-3 py-1 bg-white/20 backdrop-blur-sm rounded-full text-sm font-semibold text-white">
              Critical Intelligence
            </span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-sm text-white/90 font-medium">
              {isExpanded ? 'Hide Insights' : 'View Insights'}
            </span>
            {isExpanded ? (
              <ChevronUp className="w-6 h-6 text-white" />
            ) : (
              <ChevronDown className="w-6 h-6 text-white" />
            )}
          </div>
        </div>
      </button>

      {/* Expandable Content Area */}
      {isExpanded && (
        <div className="bg-white border-x-2 border-b-2 border-emerald-600 shadow-lg">
          <div className="max-w-7xl mx-auto px-8 py-6">
            <AIInsightsPanel 
              compact={false}
              filterByRetailer={false}
              maxInsights={20}
            />
          </div>
        </div>
      )}
    </div>
  );
}

